import { render, staticRenderFns } from "./InspectionAndMaintenance.vue?vue&type=template&id=47b04d16&scoped=true"
import script from "./InspectionAndMaintenance.vue?vue&type=script&lang=js"
export * from "./InspectionAndMaintenance.vue?vue&type=script&lang=js"
import style0 from "./InspectionAndMaintenance.vue?vue&type=style&index=0&id=47b04d16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b04d16",
  null
  
)

export default component.exports